export const calculateTextHeight = (fontSize, textId) => {
    const text = document.getElementById(textId);
    if (!text)
        return null;
    text.style.maxHeight = 'fit-content';
    text.style.fontSize = fontSize;
    const height = text.clientHeight;
    text.style.maxHeight = '';
    text.style.fontSize = '';
    return height;
};
//# sourceMappingURL=text-dimensions.js.map